import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import ReSelect, {StylesConfig} from 'react-select';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';
import {IElementMultiSelect} from '../../../../incase-domain/elements/question/multiSelect';
import QuestionLayout from '../common/QuestionLayout';
import {usePresentationLabels} from '../../../../hooks/usePresentationLabels';

function MultiselectQuestionElement(props: IQuestionElementProps<IElementMultiSelect>): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;
    const {t} = useTranslation();
    const getLabel = usePresentationLabels();
    const hostStyled = Boolean(element.htmlSlotId);

    const styles: StylesConfig = hostStyled
        ? {
              multiValue: () => ({display: 'none'}),
              singleValue: () => ({display: 'none'}),
              indicatorSeparator: () => ({display: 'none'}),
              indicatorsContainer: () => ({display: 'none'}),
              multiValueRemove: () => ({display: 'none'}),
              container: (base) => ({...base, width: '100%'}),
              control: (base) => ({
                  ...base,
                  backgroundColor: 'transparent',
                  borderColor: 'currentColor',
                  boxShadow: 'none',
                  minHeight: '2.375em',
                  cursor: 'pointer',
              }),
              placeholder: (base) => ({...base, color: 'inherit', margin: '0 0.125em'}),
              input: (base) => ({...base, color: 'inherit'}),
              valueContainer: (base) => ({
                  ...base,
                  padding: '0.125em 2.875em 0.125em .5em',
              }),
          }
        : {
              multiValue: () => ({
                  display: 'none',
              }),
              singleValue: () => ({
                  display: 'none',
              }),
              indicatorSeparator: () => ({display: 'none'}),
              indicatorsContainer: (base) => ({...base, display: 'none', padding: '.5em'}),
              dropdownIndicator: (base) => ({...base, padding: '.5em'}),
              valueContainer: (base) => ({
                  ...base,
                  padding: '0.125em 2.875em 0.125em .5em',
              }),
              placeholder: (base) => ({
                  ...base,
                  margin: '0 0.125em',
                  fontSize: '0.875em',
                  fontFamily: element.fontFamily?.name,
              }),
              input: (base) => ({...base, padding: '0.125em 0', margin: '0.125em'}),
              control: (base) => ({
                  ...base,
                  flexWrap: 'wrap',
                  fontSize: `${device === DeviceType.DESKTOP ? element.fontSize : 1}em`,
                  borderRadius: '0.5em',
                  borderWidth: '0.0625em',
                  minHeight: '2.375em',
                  cursor: 'pointer',
                  transition: 'none',
              }),
              option: (base) => ({
                  ...base,
                  fontSize: `${device === DeviceType.DESKTOP ? element.fontSize : 1}em`,
                  padding: '.2em .75em',
                  margin: '0',
                  backgroundColor: 'white !important',
                  color: '#676666',
                  cursor: 'pointer',
                  fontFamily: element.fontFamily?.name,
              }),
              container: (base) => ({...base, width: '100%'}),
              multiValueRemove: () => ({display: 'none'}),
          };

    return (
        <QuestionLayout element={element} device={device} showConfirmButton hostStyled={hostStyled}>
            <div className={`c-multiSelectElement ${device === DeviceType.MOBILE && 'c-multiSelectElement--mobile'}`}>
                <div className="c-multiSelectElement__selectContainer">
                    <div className="c-multiSelectElement__select">
                        <ReSelect
                            classNamePrefix="c-multiSelect"
                            placeholder={
                                getLabel('elements-multiselect-select') || t('presEditPage.editSidebar.elements.selectPlaceholder')
                            }
                            isDisabled
                            isMulti
                            hideSelectedOptions={false}
                            closeMenuOnSelect={false}
                            styles={styles}
                            menuPortalTarget={hostStyled ? undefined : document.body}
                        />
                    </div>
                </div>
            </div>
        </QuestionLayout>
    );
}

export default MultiselectQuestionElement;
